/**
 * Hand-drawn, per-candy Halloween effects for the Pick-n-Mix Machine.
 * Every scene is built from SVG shapes and animated with the Web Animations
 * API; nothing here uses emoji. MixFX.scene() plays a themed scene inside the
 * bag when a candy lands, MixFX.icon() returns the drawn piece that flies from
 * the card into the bag, and MixFX.meta() gives the glow color and card jolt.
 */
(function () {
  const NS = 'http://www.w3.org/2000/svg';
  const W = 280, H = 190;
  const rnd = (a, b) => a + Math.random() * (b - a);
  const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

  function S(tag, attrs, parent) {
    const e = document.createElementNS(NS, tag);
    if (attrs) for (const k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  // placed group + inner animatable group (animate the inner one in local px)
  function G(parent, x, y, s, r) {
    const p = S('g', { transform: 'translate(' + x + ' ' + y + ') rotate(' + (r || 0) + ') scale(' + (s || 1) + ')' }, parent);
    return S('g', null, p);
  }
  function go(node, frames, opts) {
    return node.animate(frames, Object.assign({ fill: 'both', easing: 'ease-out' }, opts));
  }
  const T = (x, y, r, s) => 'translate(' + x + 'px,' + y + 'px) rotate(' + (r || 0) + 'deg) scale(' + (s == null ? 1 : s) + ')';

  function stage(host) {
    const svg = S('svg', { viewBox: '0 0 ' + W + ' ' + H, width: '100%', height: '100%', preserveAspectRatio: 'xMidYMid meet' }, host);
    svg.style.cssText = 'position:absolute;inset:0;overflow:visible;pointer-events:none';
    const defs = S('defs', null, svg);
    const glow = S('filter', { id: 'fxglow', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs);
    S('feGaussianBlur', { stdDeviation: '3', result: 'b' }, glow);
    const mg = S('feMerge', null, glow);
    S('feMergeNode', { in: 'b' }, mg);
    S('feMergeNode', { in: 'SourceGraphic' }, mg);
    const lg = (id, c1, c2) => {
      const g = S('linearGradient', { id, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      S('stop', { offset: '0', 'stop-color': c1 }, g);
      S('stop', { offset: '1', 'stop-color': c2 }, g);
    };
    lg('fxflame', '#ffe27a', '#ff4a12');
    lg('fxblood', '#e11d2a', '#7a0612');
    lg('fxflesh', '#f6c9b8', '#d9937e');
    lg('fxzomb', '#9bc27a', '#4f7a3a');
    lg('fxbone', '#fffaf0', '#cfc3a6');
    const rg = (id, c1, c2) => {
      const g = S('radialGradient', { id, cx: '35%', cy: '30%', r: '75%' }, defs);
      S('stop', { offset: '0', 'stop-color': c1 }, g);
      S('stop', { offset: '1', 'stop-color': c2 }, g);
    };
    const bl = S('filter', { id: 'fxblur', x: '-60%', y: '-60%', width: '220%', height: '220%' }, defs);
    S('feGaussianBlur', { stdDeviation: '5' }, bl);
    const rb = S('linearGradient', { id: 'fxrainbow', x1: 0, y1: 0, x2: 1, y2: 0 }, defs);
    ['#ff3b3b', '#ff9a1f', '#ffe14a', '#4bd65a', '#3b9bff', '#8a4bff', '#ff4bd0'].forEach((c, i) => S('stop', { offset: String(i / 6), 'stop-color': c }, rb));
    rg('fxorb', '#e9d4ff', '#5b21b6');
    rg('fxtox', '#d8ff9a', '#37a02a');
    return { svg, defs };
  }

  // ---------- drawn parts (all centered on 0,0) ----------
  const part = {
    drop(p, c, s) { return S('path', { d: 'M0 -9 C5 -2 7 3 0 9 C-7 3 -5 -2 0 -9Z', fill: c, transform: 'scale(' + (s || 1) + ')' }, p); },
    star(p, c, s) { return S('path', { d: 'M0 -10 L2.4 -2.4 L10 0 L2.4 2.4 L0 10 L-2.4 2.4 L-10 0 L-2.4 -2.4Z', fill: c, transform: 'scale(' + (s || 1) + ')' }, p); },
    bubble(p, r, c) {
      const g = S('g', null, p);
      S('circle', { r, fill: c || 'rgba(255,255,255,0.18)', stroke: 'rgba(255,255,255,0.85)', 'stroke-width': 1.2 }, g);
      S('path', { d: 'M' + -r * 0.55 + ' ' + -r * 0.1 + ' A' + r * 0.6 + ' ' + r * 0.6 + ' 0 0 1 ' + -r * 0.05 + ' ' + -r * 0.6, fill: 'none', stroke: '#fff', 'stroke-width': 1.4, 'stroke-linecap': 'round' }, g);
      return g;
    },
    flame(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')', filter: 'url(#fxglow)' }, p);
      S('path', { d: 'M0 -26 C6 -16 16 -10 14 2 C13 11 5 16 0 16 C-6 16 -14 11 -13 2 C-12 -6 -5 -10 0 -26Z', fill: 'url(#fxflame)' }, g);
      S('path', { d: 'M0 -12 C4 -6 8 -2 7 4 C6 9 3 11 0 11 C-4 11 -7 8 -6 4 C-5 0 -2 -4 0 -12Z', fill: '#fff3b0' }, g);
      return g;
    },
    bone(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('rect', { x: -16, y: -3, width: 32, height: 6, rx: 3, fill: 'url(#fxbone)', stroke: '#b8ac8e', 'stroke-width': 0.8 }, g);
      [[-17, -5], [-17, 5], [17, -5], [17, 5]].forEach((c) => S('circle', { cx: c[0], cy: c[1], r: 4.2, fill: 'url(#fxbone)', stroke: '#b8ac8e', 'stroke-width': 0.8 }, g));
      return g;
    },
    skull(p, s, c) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M0 -16 C-12 -16 -17 -8 -17 0 C-17 6 -13 9 -10 11 L-10 16 L10 16 L10 11 C13 9 17 6 17 0 C17 -8 12 -16 0 -16Z', fill: c || 'url(#fxbone)', stroke: '#8d826a', 'stroke-width': 1 }, g);
      S('ellipse', { cx: -6, cy: 0, rx: 4, ry: 4.6, fill: '#1a0b2e' }, g);
      S('ellipse', { cx: 6, cy: 0, rx: 4, ry: 4.6, fill: '#1a0b2e' }, g);
      S('path', { d: 'M0 5 L-2.4 9 L2.4 9Z', fill: '#1a0b2e' }, g);
      S('path', { d: 'M-5 12 L-5 16 M0 12 L0 16 M5 12 L5 16', stroke: '#8d826a', 'stroke-width': 1 }, g);
      return g;
    },
    finger(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-22 -5 C-22 -8 -19 -9 -16 -9 L12 -9 C20 -9 24 -5 24 0 C24 5 20 9 12 9 L-16 9 C-19 9 -22 8 -22 5Z', fill: 'url(#fxflesh)', stroke: '#b86f5e', 'stroke-width': 1 }, g);
      S('path', { d: 'M-22 -5 L-22 5', stroke: '#b3121f', 'stroke-width': 5, 'stroke-linecap': 'round' }, g);
      S('path', { d: 'M14 -6 C20 -6 22 -3 22 0 C22 3 20 6 14 6Z', fill: '#f2e6df', stroke: '#b86f5e', 'stroke-width': 0.8 }, g);
      S('path', { d: 'M-4 -9 L-4 9 M3 -9 L3 9', stroke: '#c58572', 'stroke-width': 0.9, opacity: 0.8 }, g);
      return g;
    },
    tongue(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-40 -7 C-20 -12 10 -12 36 -6 C46 -3 48 3 38 7 C12 14 -18 14 -40 8 Z', fill: '#e0457b', stroke: '#9d1646', 'stroke-width': 1.2 }, g);
      S('path', { d: 'M-36 0 C-10 -2 14 -2 40 0', stroke: '#a01a4a', 'stroke-width': 1.4, fill: 'none', 'stroke-linecap': 'round' }, g);
      for (let i = 0; i < 12; i++) S('circle', { cx: -28 + i * 5.6, cy: rnd(-6, 6), r: 1.1, fill: '#ffb3cf' }, g);
      return g;
    },
    lips(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-28 0 C-20 -13 -7 -15 0 -8 C7 -15 20 -13 28 0 C16 4 8 3 0 4 C-8 3 -16 4 -28 0Z', fill: '#d40f4f', stroke: '#7a0a2a', 'stroke-width': 1.1 }, g);
      S('path', { d: 'M-28 0 C-16 4 -8 3 0 4 C8 3 16 4 28 0 C22 15 9 20 0 20 C-9 20 -22 15 -28 0Z', fill: '#ef2a66', stroke: '#7a0a2a', 'stroke-width': 1.1 }, g);
      S('path', { d: 'M-18 4 C-8 8 8 8 18 4', stroke: '#fff', 'stroke-width': 1.2, fill: 'none', opacity: 0.55, 'stroke-linecap': 'round' }, g);
      return g;
    },
    fang(p) { return S('path', { d: 'M0 0 L-4 0 L0 12 L4 0Z', fill: '#fff', stroke: '#c9c2b8', 'stroke-width': 0.7 }, p); },
    fly(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      const w1 = S('ellipse', { cx: -3, cy: -4, rx: 5, ry: 2.6, fill: 'rgba(210,235,255,0.75)', transform: 'rotate(-30 -3 -4)' }, g);
      const w2 = S('ellipse', { cx: 3, cy: -4, rx: 5, ry: 2.6, fill: 'rgba(210,235,255,0.75)', transform: 'rotate(30 3 -4)' }, g);
      S('ellipse', { cx: 0, cy: 0, rx: 3.2, ry: 4.4, fill: '#222' }, g);
      S('circle', { cx: 0, cy: -4, r: 2.4, fill: '#222' }, g);
      return { g, w1, w2 };
    },
    cherry(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-6 4 C-4 -8 2 -14 8 -17 M7 5 C7 -6 8 -12 8 -17', stroke: '#3c7a2a', 'stroke-width': 1.8, fill: 'none', 'stroke-linecap': 'round' }, g);
      [[-7, 8], [8, 9]].forEach((c) => {
        S('circle', { cx: c[0], cy: c[1], r: 8, fill: '#c4161c' }, g);
        S('circle', { cx: c[0] - 2.5, cy: c[1] - 3, r: 2.2, fill: 'rgba(255,255,255,0.6)' }, g);
      });
      return g;
    },
    berry(p, c, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('circle', { r: 9, fill: c }, g);
      S('circle', { cx: -3, cy: -3, r: 2.4, fill: 'rgba(255,255,255,0.45)' }, g);
      S('path', { d: 'M-4 -9 L0 -5 L4 -9', stroke: '#3a7a2e', 'stroke-width': 1.8, fill: 'none', 'stroke-linecap': 'round' }, g);
      return g;
    },
    raspberry(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      [[0, -5], [-5, -1], [5, -1], [-3, 5], [3, 5], [0, 1], [-7, 6], [7, 6]].forEach((c) => {
        S('circle', { cx: c[0], cy: c[1], r: 3.9, fill: '#d6246e' }, g);
        S('circle', { cx: c[0] - 1, cy: c[1] - 1, r: 1, fill: 'rgba(255,255,255,0.5)' }, g);
      });
      return g;
    },
    lemon(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('circle', { r: 12, fill: '#ffe14a', stroke: '#e0b800', 'stroke-width': 2 }, g);
      S('circle', { r: 9.4, fill: '#fff3a0' }, g);
      for (let i = 0; i < 8; i++) S('path', { d: 'M0 0 L0 -9', stroke: '#f2c500', 'stroke-width': 1, transform: 'rotate(' + i * 45 + ')' }, g);
      return g;
    },
    trefoil(p, s, c) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')', filter: 'url(#fxglow)' }, p);
      for (let i = 0; i < 3; i++) {
        S('path', { d: 'M0 0 L-9 -15.6 A18 18 0 0 1 9 -15.6Z', fill: c || '#8bff3c', transform: 'rotate(' + i * 120 + ')' }, g);
      }
      S('circle', { r: 3.4, fill: '#12240a', stroke: c || '#8bff3c', 'stroke-width': 1.4 }, g);
      return g;
    },
    hand(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-12 18 L-12 2 C-12 -2 -9 -4 -6 -4 L8 -4 C12 -4 14 -1 14 3 L14 18Z', fill: 'url(#fxzomb)', stroke: '#35572a', 'stroke-width': 1 }, g);
      [[-11, -4, -8], [-5, -5, -3], [1, -5, 2], [7, -4, 7]].forEach((f, i) => {
        S('path', { d: 'M' + f[0] + ' ' + f[1] + ' L' + (f[0] + f[2] * 0.8) + ' ' + (f[1] - 17 - (i === 1 || i === 2 ? 4 : 0)), stroke: '#6f9d55', 'stroke-width': 5.2, 'stroke-linecap': 'round' }, g);
        S('path', { d: 'M' + f[0] + ' ' + f[1] + ' L' + (f[0] + f[2] * 0.8) + ' ' + (f[1] - 17 - (i === 1 || i === 2 ? 4 : 0)), stroke: '#35572a', 'stroke-width': 0.8, 'stroke-linecap': 'round' }, g);
      });
      S('path', { d: 'M-8 6 L-2 8 M4 10 L10 8', stroke: '#35572a', 'stroke-width': 1, 'stroke-linecap': 'round' }, g);
      return g;
    },
    bottle(p, liquid, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-4 -18 L4 -18 L4 -8 C12 -4 14 4 14 10 C14 16 9 18 0 18 C-9 18 -14 16 -14 10 C-14 4 -12 -4 -4 -8Z', fill: 'rgba(200,235,255,0.35)', stroke: 'rgba(255,255,255,0.9)', 'stroke-width': 1.3 }, g);
      S('path', { d: 'M-12 8 C-8 5 8 11 12 7 L12 11 C12 16 8 17 0 17 C-8 17 -12 16 -12 11Z', fill: liquid }, g);
      S('rect', { x: -4, y: -22, width: 8, height: 5, rx: 1.5, fill: '#8a5a2a' }, g);
      return g;
    },
    orb(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('circle', { r: 17, fill: 'url(#fxorb)', stroke: '#e5d0ff', 'stroke-width': 1.2, filter: 'url(#fxglow)' }, g);
      S('path', { d: 'M-10 4 C-4 -8 6 -8 10 -2 C4 -4 -2 0 -10 4Z', fill: 'rgba(255,255,255,0.35)' }, g);
      S('ellipse', { cx: -6, cy: -8, rx: 4, ry: 2.4, fill: 'rgba(255,255,255,0.55)', transform: 'rotate(-35 -6 -8)' }, g);
      S('path', { d: 'M-8 18 L8 18 L11 23 L-11 23Z', fill: '#3a2552' }, g);
      return g;
    },
    cauldron(p, s) {
      const g = S('g', { transform: 'scale(' + (s || 1) + ')' }, p);
      S('path', { d: 'M-22 -6 C-26 8 -16 20 0 20 C16 20 26 8 22 -6Z', fill: '#1b1424', stroke: '#4a3a66', 'stroke-width': 1.4 }, g);
      S('ellipse', { cx: 0, cy: -6, rx: 22, ry: 6, fill: '#37a02a' }, g);
      S('ellipse', { cx: 0, cy: -6, rx: 17, ry: 3.6, fill: '#8bff6a', opacity: 0.8 }, g);
      S('path', { d: 'M-14 18 L-17 25 M14 18 L17 25', stroke: '#1b1424', 'stroke-width': 3, 'stroke-linecap': 'round' }, g);
      return g;
    },
    rune(p, c) {
      const g = S('g', { filter: 'url(#fxglow)' }, p);
      S('circle', { r: 34, fill: 'none', stroke: c, 'stroke-width': 1.6 }, g);
      S('circle', { r: 28, fill: 'none', stroke: c, 'stroke-width': 0.8, 'stroke-dasharray': '3 4' }, g);
      let d = '';
      for (let i = 0; i < 5; i++) {
        const a = (i * 144 - 90) * Math.PI / 180;
        d += (i ? 'L' : 'M') + (28 * Math.cos(a)).toFixed(1) + ' ' + (28 * Math.sin(a)).toFixed(1);
      }
      S('path', { d: d + 'Z', fill: 'none', stroke: c, 'stroke-width': 1.4, 'stroke-linejoin': 'round' }, g);
      return g;
    },
  };

  // flying piece: small drawn icon per candy (40x40 viewBox centered at 20,20)
  function icon(handle) {
    const m = META[handle] || META._default;
    const svg = S('svg', { viewBox: '-26 -26 52 52', width: 44, height: 44 });
    svg.style.overflow = 'visible';
    const defs = S('defs', null, svg);
    ['flame:#ffe27a:#ff4a12', 'blood:#e11d2a:#7a0612', 'flesh:#f6c9b8:#d9937e', 'zomb:#9bc27a:#4f7a3a', 'bone:#fffaf0:#cfc3a6'].forEach((s) => {
      const [n, a, b] = s.split(':');
      const lg = S('linearGradient', { id: 'fx' + n, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      S('stop', { offset: '0', 'stop-color': a }, lg);
      S('stop', { offset: '1', 'stop-color': b }, lg);
    });
    const rg = S('radialGradient', { id: 'fxorb', cx: '35%', cy: '30%', r: '75%' }, defs);
    S('stop', { offset: '0', 'stop-color': '#e9d4ff' }, rg);
    S('stop', { offset: '1', 'stop-color': '#5b21b6' }, rg);
    const f = S('filter', { id: 'fxglow' }, defs);
    S('feGaussianBlur', { stdDeviation: '2' }, f);
    const g = S('g', null, svg);
    (m.icon || ICONS.skull)(g);
    return svg;
  }
  const ICONS = {
    skull: (g) => part.skull(g, 1.1),
    tongue: (g) => part.tongue(g, 0.55),
    lips: (g) => part.lips(g, 0.8),
    finger: (g) => part.finger(g, 0.95),
    flame: (g) => part.flame(g, 1.1),
    bone: (g) => part.bone(g, 1.3),
    orb: (g) => part.orb(g, 1.05),
    trefoil: (g) => part.trefoil(g, 1.3),
    hand: (g) => part.hand(g, 0.9),
    bottle: (g) => part.bottle(g, '#5cff7a', 1.1),
    bottleP: (g) => part.bottle(g, '#a66bff', 1.1),
    cherry: (g) => part.cherry(g, 1.2),
    raspberry: (g) => part.raspberry(g, 1.5),
    lemon: (g) => part.lemon(g, 1.3),
    drop: (g) => part.drop(g, '#c4161c', 2.2),
    star: (g) => part.star(g, '#ffd04a', 1.6),
    bubble: (g) => part.bubble(g, 12),
    cauldron: (g) => part.cauldron(g, 0.9),
  };

  // ---------- scenes (all play in a 280x190 bag-sized stage) ----------
  const cx = W / 2, cy = 112, floor = 172;

  function splat(p, color, x, y, s) {
    const g = G(p, x, y, s || 1, rnd(0, 360));
    S('circle', { r: 9, fill: color }, g);
    for (let i = 0; i < 9; i++) {
      const a = (i / 9) * Math.PI * 2 + rnd(-0.2, 0.2), l = rnd(11, 24);
      S('path', { d: 'M0 0 L' + (Math.cos(a) * l).toFixed(1) + ' ' + (Math.sin(a) * l).toFixed(1), stroke: color, 'stroke-width': rnd(2, 4.5), 'stroke-linecap': 'round' }, g);
      S('circle', { cx: Math.cos(a) * (l + 4), cy: Math.sin(a) * (l + 4), r: rnd(1.4, 3), fill: color }, g);
    }
    return g;
  }
  function drip(p, color, x, y, len, delay) {
    const g = G(p, x, y, 1, 0);
    S('path', { d: 'M0 0 L0 ' + len, stroke: color, 'stroke-width': 3.4, 'stroke-linecap': 'round' }, g);
    S('circle', { cy: len, r: 3.6, fill: color }, g);
    go(g, [{ transform: 'scaleY(0)', opacity: 0, transformOrigin: '0 0' }, { transform: 'scaleY(1)', opacity: 1, transformOrigin: '0 0' }], { duration: 900, delay, easing: 'cubic-bezier(.4,0,.6,1)' });
  }
  function sparks(p, color, x, y, n, dist, size) {
    for (let i = 0; i < n; i++) {
      const a = (i / n) * Math.PI * 2 + rnd(-0.3, 0.3), d = rnd(dist * 0.6, dist);
      const g = G(p, x, y, 1, 0);
      part.star(g, color, size || 0.5);
      go(g, [{ transform: T(0, 0, 0, 0.2), opacity: 1 }, { transform: T(Math.cos(a) * d, Math.sin(a) * d, rnd(-90, 90), 1), opacity: 1, offset: 0.4 }, { transform: T(Math.cos(a) * d * 1.2, Math.sin(a) * d * 1.2 + 14, rnd(-180, 180), 0.2), opacity: 0 }], { duration: rnd(700, 1100), delay: rnd(0, 160) });
    }
  }
  function bubblesUp(p, x0, x1, n, color) {
    for (let i = 0; i < n; i++) {
      const g = G(p, rnd(x0, x1), floor, 1, 0);
      part.bubble(g, rnd(3, 8), color);
      const dx = rnd(-14, 14);
      go(g, [{ transform: T(0, 0, 0, 0.4), opacity: 0 }, { transform: T(dx, -50, 0, 1), opacity: 1, offset: 0.4 }, { transform: T(-dx, -118, 0, 1.15), opacity: 0 }], { duration: rnd(900, 1400), delay: i * 70 });
    }
  }
  function glassShine(p, color) {
    const r = S('rect', { x: 36, y: 40, width: 208, height: 140, rx: 14, fill: color, opacity: 0 }, p);
    go(r, [{ opacity: 0 }, { opacity: 0.4, offset: 0.25 }, { opacity: 0 }], { duration: 900 });
  }

  const SCENES = {
    // long drawn tongue licks across the glass, leaving a wet streak and a drool drip
    tongue(p) {
      const wet = S('path', { d: 'M52 96 C100 84 170 108 228 92', stroke: 'rgba(255,200,225,0.55)', 'stroke-width': 17, fill: 'none', 'stroke-linecap': 'round', pathLength: 1 }, p);
      wet.style.strokeDasharray = 1;
      go(wet, [{ strokeDashoffset: 1, opacity: 1 }, { strokeDashoffset: 0, opacity: 1, offset: 0.5 }, { strokeDashoffset: 0, opacity: 0 }], { duration: 1500 });
      const t = G(p, 0, 98, 1.5, -4);
      part.tongue(t, 1);
      go(t, [{ transform: T(-70, 0, -8, 1) }, { transform: T(150, -10, 4, 1.1), offset: 0.45 }, { transform: T(150, -10, 4, 1.1), offset: 0.55 }, { transform: T(300, 4, -4, 1) }], { duration: 1100, easing: 'cubic-bezier(.5,0,.5,1)' });
      drip(p, 'rgba(255,170,205,0.9)', 120, 104, 22, 520);
      drip(p, 'rgba(255,170,205,0.9)', 178, 100, 30, 640);
    },
    // red lips kiss the glass, leave a lipstick print, and fangs flash with a blood drop
    lips(p) {
      const k = G(p, cx, 100, 1.9, 0);
      part.lips(k, 1);
      const fl = G(k, -9, 8, 1, 0); part.fang(fl);
      const fr = G(k, 9, 8, 1, 0); part.fang(fr);
      go(k, [{ transform: T(0, 40, 0, 0.1), opacity: 0 }, { transform: T(0, 0, 0, 1.15), opacity: 1, offset: 0.3 }, { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.7 }, { transform: T(0, -10, 0, 1.1), opacity: 0 }], { duration: 1300 });
      go(fl, [{ transform: T(0, 0, 0, 0) }, { transform: T(0, 0, 0, 0), offset: 0.45 }, { transform: T(0, 0, 0, 1.2), offset: 0.55 }, { transform: T(0, 0, 0, 1) }], { duration: 1300 });
      go(fr, [{ transform: T(0, 0, 0, 0) }, { transform: T(0, 0, 0, 0), offset: 0.45 }, { transform: T(0, 0, 0, 1.2), offset: 0.55 }, { transform: T(0, 0, 0, 1) }], { duration: 1300 });
      for (let i = 0; i < 5; i++) {
        const h = G(p, cx + rnd(-60, 60), 70 + rnd(0, 20), 1, 0);
        part.drop(h, '#ff3c7a', rnd(0.6, 1));
        go(h, [{ transform: T(0, 0, 0, 0.2), opacity: 0 }, { transform: T(0, -14, 0, 1), opacity: 1, offset: 0.4 }, { transform: T(rnd(-18, 18), -34, 0, 0.6), opacity: 0 }], { duration: 1000, delay: 300 + i * 90 });
      }
      drip(p, '#b3121f', cx - 9, 118, 24, 800);
    },
    // a bony hand claws up out of dirt in the bottom of the bag; a skull and bones follow
    unearthed(p) {
      const mound = S('path', { d: 'M20 190 C50 150 90 150 120 160 C160 150 220 148 262 190Z', fill: '#4a2f1a' }, p);
      go(mound, [{ transform: 'translateY(60px)' }, { transform: 'translateY(0)' }], { duration: 400 });
      const sk = G(p, cx, 150, 1.8, 0);
      part.skull(sk, 1);
      go(sk, [{ transform: T(0, 50, 0, 0.8), opacity: 0 }, { transform: T(0, -34, 8, 1), opacity: 1, offset: 0.55 }, { transform: T(0, -30, -6, 1), opacity: 1, offset: 0.8 }, { transform: T(0, 40, 0, 0.9), opacity: 0 }], { duration: 1500, delay: 200 });
      for (let i = 0; i < 12; i++) {
        const c = G(p, rnd(70, 210), 150, 1, 0);
        S('circle', { r: rnd(1.5, 3.4), fill: '#6b4425' }, c);
        go(c, [{ transform: T(0, 0), opacity: 1 }, { transform: T(rnd(-24, 24), -rnd(24, 60)), opacity: 1, offset: 0.4 }, { transform: T(rnd(-30, 30), 28), opacity: 0 }], { duration: 1100, delay: 200 + i * 40 });
      }
      [[-60, 0.8, -25], [64, 0.7, 20]].forEach((b, i) => {
        const bone = G(p, cx + b[0], 150, b[1] * 1.3, b[2]);
        part.bone(bone, 1);
        go(bone, [{ transform: T(0, 40, 0), opacity: 0 }, { transform: T(0, -26, 90 * (i ? 1 : -1)), opacity: 1, offset: 0.5 }, { transform: T(0, 30, 160 * (i ? 1 : -1)), opacity: 0 }], { duration: 1300, delay: 450 });
      });
    },
    // flames: a real layered fire roars up the bag with a heat wash and embers
    inferno(p) {
      glassShine(p, '#ff6a1a');
      [[cx - 52, 0.95, 0], [cx + 50, 0.85, 120], [cx, 1.5, 60]].forEach((f, i) => {
        const g = G(p, f[0], floor, f[1], 0);
        part.flame(g, 1.4);
        go(g, [{ transform: T(0, 20, 0, 0.1), opacity: 0 }, { transform: T(0, 0, rnd(-4, 4), 1.1), opacity: 1, offset: 0.25 }, { transform: T(0, -6, rnd(-5, 5), 1.0), opacity: 1, offset: 0.5 }, { transform: T(0, -10, rnd(-6, 6), 1.15), opacity: 1, offset: 0.75 }, { transform: T(0, -30, 0, 0.3), opacity: 0 }], { duration: 1500, delay: f[2] });
      });
      for (let i = 0; i < 12; i++) {
        const e = G(p, rnd(60, 220), floor - 10, 1, 0);
        S('circle', { r: rnd(1.2, 2.6), fill: pick(['#ffcf5c', '#ff8a2a', '#fff0a0']) }, e);
        go(e, [{ transform: T(0, 0), opacity: 0 }, { transform: T(rnd(-14, 14), -50, 0), opacity: 1, offset: 0.3 }, { transform: T(rnd(-24, 24), -130, 0), opacity: 0 }], { duration: rnd(900, 1400), delay: i * 60 });
      }
    },
    // a skull whose eyes become hypnotic spirals; drawn stars orbit and the glass wobbles
    dizzy(p) {
      const sk = G(p, cx, 102, 2.2, 0);
      part.skull(sk, 1);
      ['-6', '6'].forEach((x) => {
        const sp = S('path', { d: 'M0 0 m0 -1 a1 1 0 1 1 -1.5 0.5 a2.4 2.4 0 1 1 3.2 -0.4 a3.8 3.8 0 1 1 -5 -0.8', stroke: '#7fd6ff', 'stroke-width': 0.9, fill: 'none', transform: 'translate(' + x + ' 0)' }, sk);
        sp.style.transformBox = 'fill-box'; sp.style.transformOrigin = 'center';
        go(sp, [{ transform: 'rotate(0deg)' }, { transform: 'rotate(1080deg)' }], { duration: 1600, easing: 'linear' });
      });
      go(sk, [{ transform: T(0, 20, 0, 0.3), opacity: 0 }, { transform: T(0, 0, -10, 1) , opacity: 1, offset: 0.2 }, { transform: T(0, 0, 10, 1), offset: 0.4 }, { transform: T(0, 0, -8, 1), offset: 0.6 }, { transform: T(0, 0, 6, 1), offset: 0.8 }, { transform: T(0, -20, 0, 1), opacity: 0 }], { duration: 1600 });
      for (let i = 0; i < 6; i++) {
        const s = G(p, cx, 62, 1, 0);
        part.star(s, pick(['#ffe14a', '#7fd6ff', '#ff9fd0']), 0.8);
        const a0 = (i / 6) * Math.PI * 2;
        const fr = [];
        for (let k = 0; k <= 10; k++) { const a = a0 + (k / 10) * Math.PI * 4; fr.push({ transform: T(Math.cos(a) * 58, Math.sin(a) * 18, k * 60, 1), opacity: k === 0 || k === 10 ? 0 : 1, offset: k / 10 }); }
        go(s, fr, { duration: 1600, easing: 'linear' });
      }
    },
    // summoning: a dark vortex tears open, a rune circle burns on the floor, purple lightning arcs,
    // a spectral skull screams out of the portal and dissolves into smoke
    blackmagic(p) {
      glassShine(p, '#7b3fe4');
      // black smoke plume behind everything
      for (let i = 0; i < 9; i++) {
        const sm = G(p, cx + rnd(-46, 46), 150, 1, 0);
        S('circle', { r: rnd(18, 30), fill: pick(['#0c0314', '#1a0b2e', '#241048']), opacity: 0.8, filter: 'url(#fxblur)' }, sm);
        go(sm, [{ transform: T(0, 0, 0, 0.3), opacity: 0 }, { transform: T(rnd(-14, 14), -40, 0, 1.2), opacity: 0.85, offset: 0.35 }, { transform: T(rnd(-34, 34), -120, 0, 1.9), opacity: 0 }], { duration: 1700, delay: i * 90 });
      }
      // rune circle drawing itself on the floor
      const fl = G(p, cx, 156, 1, 0);
      fl.parentNode.setAttribute('transform', 'translate(' + cx + ' 156) scale(1.9 0.42)');
      const rune = part.rune(fl, '#b27bff');
      [...rune.querySelectorAll('circle,path')].forEach((n) => { n.setAttribute('pathLength', 1); n.style.strokeDasharray = 1; });
      go(rune, [{ transform: 'rotate(0deg)', opacity: 0 }, { transform: 'rotate(90deg)', opacity: 1, offset: 0.25 }, { transform: 'rotate(300deg)', opacity: 1, offset: 0.8 }, { transform: 'rotate(380deg)', opacity: 0 }], { duration: 1800, easing: 'linear' });
      [...rune.querySelectorAll('circle,path')].forEach((n, i) => go(n, [{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], { duration: 600, delay: i * 90 }));
      // beams of violet light rising off the circle
      for (let i = 0; i < 5; i++) {
        const b = S('rect', { x: cx - 70 + i * 35, y: 40, width: 7, height: 120, fill: '#b27bff', opacity: 0, rx: 3.5, filter: 'url(#fxblur)' }, p);
        go(b, [{ opacity: 0, transform: 'scaleY(0.2)' }, { opacity: 0.7, transform: 'scaleY(1)', offset: 0.35 }, { opacity: 0, transform: 'scaleY(1.1)' }], { duration: 1300, delay: 250 + i * 70 });
        b.style.transformBox = 'fill-box'; b.style.transformOrigin = 'bottom';
      }
      // the vortex: six rotating spiral arms
      const v = G(p, cx, 104, 1, 0);
      for (let i = 0; i < 6; i++) {
        S('path', { d: 'M0 0 C14 -8 30 -4 38 8 C46 22 34 40 14 44', stroke: i % 2 ? '#5b2a99' : '#14061f', 'stroke-width': 11 - i, fill: 'none', 'stroke-linecap': 'round', transform: 'rotate(' + i * 60 + ')', opacity: 0.95 }, v);
      }
      S('circle', { r: 12, fill: '#000', filter: 'url(#fxglow)' }, v);
      go(v, [{ transform: 'rotate(0deg) scale(0)', opacity: 0 }, { transform: 'rotate(260deg) scale(1.2)', opacity: 1, offset: 0.3 }, { transform: 'rotate(720deg) scale(1.15)', opacity: 1, offset: 0.78 }, { transform: 'rotate(900deg) scale(0)', opacity: 0 }], { duration: 1800, easing: 'ease-in-out' });
      // spectral skull screams out
      const sp = G(p, cx, 104, 2.4, 0);
      const sk = part.skull(sp, 1);
      sk.setAttribute('opacity', '0.9');
      sk.querySelector('path').setAttribute('fill', '#c9a3ff');
      const jaw = S('rect', { x: -9, y: 12, width: 18, height: 7, rx: 2, fill: '#1a0b2e' }, sk);
      go(jaw, [{ transform: 'translateY(0)' }, { transform: 'translateY(0)', offset: 0.4 }, { transform: 'translateY(7px)', offset: 0.55 }, { transform: 'translateY(8px)', offset: 0.75 }, { transform: 'translateY(0)' }], { duration: 1600, delay: 250 });
      sk.querySelectorAll('ellipse').forEach((e) => { e.setAttribute('fill', '#b27bff'); e.setAttribute('filter', 'url(#fxglow)'); });
      const tail = S('path', { d: 'M-10 14 C-14 30 -4 40 -8 56 M0 16 C-2 34 6 44 2 62 M10 14 C14 30 4 40 8 54', stroke: 'rgba(201,163,255,0.7)', 'stroke-width': 5, fill: 'none', 'stroke-linecap': 'round' }, sk);
      go(sp, [{ transform: T(0, 50, 0, 0.1), opacity: 0 }, { transform: T(0, -2, 0, 1.15), opacity: 1, offset: 0.35 }, { transform: T(-6, -8, -6, 1.2), opacity: 1, offset: 0.55 }, { transform: T(6, -14, 6, 1.2), opacity: 1, offset: 0.72 }, { transform: T(0, -50, 0, 1.4), opacity: 0 }], { duration: 1800, delay: 150 });
      // lightning between the portal and the glass
      for (let i = 0; i < 5; i++) {
        const a = rnd(0, Math.PI * 2), len = rnd(70, 110);
        let d = 'M' + cx + ' 104', x = cx, y = 104;
        for (let k = 1; k <= 6; k++) { x = cx + Math.cos(a) * len * (k / 6) + rnd(-12, 12); y = 104 + Math.sin(a) * len * 0.8 * (k / 6) + rnd(-10, 10); d += ' L' + x.toFixed(0) + ' ' + y.toFixed(0); }
        const bolt = S('path', { d, stroke: '#e7d3ff', 'stroke-width': 2.4, fill: 'none', 'stroke-linejoin': 'round', filter: 'url(#fxglow)', opacity: 0 }, p);
        go(bolt, [{ opacity: 0 }, { opacity: 1, offset: 0.2 }, { opacity: 0.1, offset: 0.5 }, { opacity: 0.9, offset: 0.7 }, { opacity: 0 }], { duration: 260, delay: 350 + i * 170 });
      }
      sparks(p, '#d9b3ff', cx, 104, 12, 100, 0.55);
    },
    // glowing orb: swirling smoke, a creepy eye opens, rings ripple out
    orb(p) {
      const o = G(p, cx, 104, 2.6, 0);
      part.orb(o, 1);
      const eye = S('g', null, o);
      S('ellipse', { rx: 8, ry: 4.4, fill: '#fff', stroke: '#2a1245', 'stroke-width': 0.8 }, eye);
      const iris = S('circle', { r: 2.6, fill: '#b3121f' }, eye);
      S('circle', { r: 1, fill: '#000' }, eye);
      go(eye, [{ transform: 'scaleY(0)' }, { transform: 'scaleY(0)', offset: 0.35 }, { transform: 'scaleY(1)', offset: 0.5 }, { transform: 'scaleY(1)', offset: 0.78 }, { transform: 'scaleY(0.05)', offset: 0.88 }, { transform: 'scaleY(1)' }], { duration: 1600 });
      go(iris, [{ transform: 'translateX(-3px)' }, { transform: 'translateX(3px)' }, { transform: 'translateX(-3px)' }], { duration: 1600 });
      go(o, [{ transform: T(0, 30, 0, 0.3), opacity: 0 }, { transform: T(0, 0, 0, 1.05), opacity: 1, offset: 0.3 }, { transform: T(0, -4, 0, 1), opacity: 1, offset: 0.85 }, { transform: T(0, -10, 0, 1.2), opacity: 0 }], { duration: 1700 });
      for (let i = 0; i < 3; i++) {
        const ring = S('circle', { cx, cy: 104, r: 18, fill: 'none', stroke: '#c79bff', 'stroke-width': 2 }, p);
        ring.style.transformBox = 'fill-box'; ring.style.transformOrigin = 'center';
        go(ring, [{ transform: 'scale(0.4)', opacity: 0.9 }, { transform: 'scale(3.4)', opacity: 0 }], { duration: 1100, delay: 250 + i * 260 });
      }
      sparks(p, '#e9d4ff', cx, 104, 8, 78, 0.5);
    },
    // blood splatter hits the glass and runs down in streaks
    splatter(p, color) {
      color = color || '#c4161c';
      [[96, 80, 1.3, 0], [186, 96, 1.7, 90], [140, 128, 1.1, 170]].forEach((s) => {
        const g = splat(p, color, s[0], s[1], s[2]);
        go(g, [{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(1.25)', opacity: 1, offset: 0.2 }, { transform: 'scale(1)', opacity: 1, offset: 0.35 }, { transform: 'scale(1)', opacity: 1, offset: 0.8 }, { transform: 'scale(1)', opacity: 0 }], { duration: 1700, delay: s[3] });
        drip(p, color, s[0] + rnd(-8, 8), s[1] + 8, rnd(30, 56), s[3] + 300);
      });
    },
    // radiation: a glowing trefoil spins in, pulses green rings, and sparks arc
    radioactive(p) {
      glassShine(p, '#7cff3c');
      const t = G(p, cx, 104, 2.6, 0);
      part.trefoil(t, 1);
      go(t, [{ transform: T(0, 0, -180, 0.2), opacity: 0 }, { transform: T(0, 0, 0, 1.15), opacity: 1, offset: 0.35 }, { transform: T(0, 0, 90, 1), opacity: 1, offset: 0.75 }, { transform: T(0, 0, 200, 1.3), opacity: 0 }], { duration: 1600 });
      for (let i = 0; i < 4; i++) {
        const ring = S('circle', { cx, cy: 104, r: 22, fill: 'none', stroke: '#8bff3c', 'stroke-width': 2.4 }, p);
        ring.style.transformBox = 'fill-box'; ring.style.transformOrigin = 'center';
        go(ring, [{ transform: 'scale(0.3)', opacity: 0.95 }, { transform: 'scale(3.2)', opacity: 0 }], { duration: 1000, delay: 200 + i * 220 });
      }
      for (let i = 0; i < 10; i++) {
        const b = G(p, cx, 104, 1, 0);
        S('circle', { r: rnd(1.8, 3.4), fill: '#c4ff7a', filter: 'url(#fxglow)' }, b);
        const a = rnd(0, Math.PI * 2), d = rnd(50, 96);
        go(b, [{ transform: T(0, 0), opacity: 1 }, { transform: T(Math.cos(a) * d, Math.sin(a) * d * 0.7), opacity: 0 }], { duration: rnd(700, 1100), delay: 300 + i * 50 });
      }
    },
    // dripping blood falls and pools in the bottom of the bag
    bloodberry(p) {
      for (let i = 0; i < 7; i++) {
        const x = 60 + i * 26 + rnd(-6, 6);
        const g = G(p, x, 46, 1, 0);
        part.drop(g, i % 2 ? '#b3122b' : '#d11a36', rnd(0.9, 1.5));
        go(g, [{ transform: T(0, 0, 0, 0.3), opacity: 0 }, { transform: T(0, 12, 0, 1), opacity: 1, offset: 0.2 }, { transform: T(0, floor - 56, 0, 1.1), opacity: 1, offset: 0.7 }, { transform: T(0, floor - 46, 0, 0.4), opacity: 0 }], { duration: 1100, delay: i * 90, easing: 'cubic-bezier(.5,0,.9,.6)' });
      }
      const pool = S('ellipse', { cx, cy: floor + 4, rx: 96, ry: 8, fill: '#a3111f' }, p);
      pool.style.transformBox = 'fill-box'; pool.style.transformOrigin = 'center';
      go(pool, [{ transform: 'scaleX(0.04)', opacity: 0 }, { transform: 'scaleX(0.04)', opacity: 0, offset: 0.4 }, { transform: 'scaleX(0.95)', opacity: 1, offset: 0.7 }, { transform: 'scaleX(1)', opacity: 0 }], { duration: 1500 });
      const b = G(p, cx, 96, 1.7, 0);
      part.berry(b, '#9b1b3a', 1);
      go(b, [{ transform: T(0, -30, 0, 0.2), opacity: 0 }, { transform: T(0, 0, 0, 1.2), opacity: 1, offset: 0.3 }, { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.6 }, { transform: T(0, 30, 0, 0.5), opacity: 0 }], { duration: 1300 });
    },
    // a drawn bottle tips and pours glowing liquid that fills the bag with bubbles
    potion(p, color) {
      color = color || '#5cff7a';
      const b = G(p, 70, 40, 2, 0);
      part.bottle(b, color, 1);
      go(b, [{ transform: T(0, -30, 0, 0.5), opacity: 0 }, { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.2 }, { transform: T(36, 6, 100, 1), offset: 0.45 }, { transform: T(36, 6, 120, 1), offset: 0.75 }, { transform: T(0, -20, 0, 0.8), opacity: 0 }], { duration: 1500 });
      const stream = S('path', { d: 'M118 62 C124 90 124 120 122 150', stroke: color, 'stroke-width': 7, fill: 'none', 'stroke-linecap': 'round', pathLength: 1, opacity: 0.9, filter: 'url(#fxglow)' }, p);
      stream.style.strokeDasharray = 1;
      go(stream, [{ strokeDashoffset: 1, opacity: 0 }, { strokeDashoffset: 1, opacity: 0, offset: 0.4 }, { strokeDashoffset: 0, opacity: 1, offset: 0.55 }, { strokeDashoffset: 0, opacity: 1, offset: 0.78 }, { strokeDashoffset: -1, opacity: 0 }], { duration: 1500 });
      const lvl = S('rect', { x: 36, y: floor - 46, width: 208, height: 54, fill: color, opacity: 0.55, rx: 8 }, p);
      lvl.style.transformBox = 'fill-box'; lvl.style.transformOrigin = 'bottom';
      go(lvl, [{ transform: 'scaleY(0)', opacity: 0.55 }, { transform: 'scaleY(0)', opacity: 0.55, offset: 0.45 }, { transform: 'scaleY(1)', opacity: 0.55, offset: 0.8 }, { transform: 'scaleY(1)', opacity: 0 }], { duration: 1700 });
      setTimeout(() => bubblesUp(p, 70, 210, 12, 'rgba(255,255,255,0.18)'), 650);
      sparks(p, '#ffffff', 124, 140, 8, 50, 0.4);
    },
    // a drawn zombie hand grabs up through the bag with dirt; fingers clutch
    zombiehand(p) {
      [[cx - 46, 0.2, 0], [cx + 40, -0.15, 160]].forEach((h, i) => {
        const g = G(p, h[0], floor + 6, 2.3, h[1] * 20);
        part.hand(g, 1);
        go(g, [{ transform: T(0, 70, 0, 1), opacity: 1 }, { transform: T(0, -36, 0, 1), opacity: 1, offset: 0.4 }, { transform: T(0, -34, i ? -8 : 8, 1), offset: 0.55 }, { transform: T(0, -38, i ? 8 : -8, 1), offset: 0.7 }, { transform: T(0, 70, 0, 1), opacity: 1 }], { duration: 1600, delay: h[2] });
      });
      for (let i = 0; i < 14; i++) {
        const c = G(p, rnd(50, 230), floor, 1, 0);
        S('circle', { r: rnd(1.4, 3.2), fill: pick(['#4a2f1a', '#6b4425', '#35572a']) }, c);
        go(c, [{ transform: T(0, 0), opacity: 1 }, { transform: T(rnd(-20, 20), -rnd(30, 70)), opacity: 1, offset: 0.4 }, { transform: T(rnd(-26, 26), 16), opacity: 0 }], { duration: 1000, delay: i * 50 });
      }
    },
    // fingers crawl across the bag floor on their knuckles, then wave
    fingers(p) {
      for (let i = 0; i < 4; i++) {
        const f = G(p, 0, floor - 6 - (i % 2) * 8, 1.15, rnd(-6, 6));
        part.finger(f, 1);
        const x0 = i % 2 ? 300 : -40, x1 = i % 2 ? 40 : 240;
        const fr = [];
        const steps = 8;
        for (let k = 0; k <= steps; k++) {
          const u = k / steps;
          fr.push({ transform: T(x0 + (x1 - x0) * u, k % 2 ? -8 : 0, (i % 2 ? 180 : 0) + (k % 2 ? -10 : 10), 1), offset: u });
        }
        go(f, fr, { duration: 1500, delay: i * 140, easing: 'linear' });
      }
      for (let i = 0; i < 6; i++) drip(p, '#b3121f', rnd(50, 230), floor - 10, rnd(6, 16), 300 + i * 100);
    },
    // a hopping drawn monkey head with stitches and X eyes bounces across the bag
    monkey(p) {
      for (let i = 0; i < 3; i++) {
        const g = G(p, 0, floor - 6, 1.5, 0);
        const m = S('g', null, g);
        S('circle', { cx: -15, cy: -2, r: 6, fill: '#8a5a3a' }, m); S('circle', { cx: 15, cy: -2, r: 6, fill: '#8a5a3a' }, m);
        S('circle', { r: 15, fill: '#a56d46', stroke: '#5b3a22', 'stroke-width': 1 }, m);
        S('ellipse', { cy: 5, rx: 9.5, ry: 7, fill: '#e9c79a' }, m);
        [[-6, -4], [6, -4]].forEach((e) => S('path', { d: 'M' + (e[0] - 2.4) + ' ' + (e[1] - 2.4) + ' L' + (e[0] + 2.4) + ' ' + (e[1] + 2.4) + ' M' + (e[0] + 2.4) + ' ' + (e[1] - 2.4) + ' L' + (e[0] - 2.4) + ' ' + (e[1] + 2.4), stroke: '#1a0b2e', 'stroke-width': 1.6, 'stroke-linecap': 'round' }, m));
        S('path', { d: 'M-5 8 Q0 11 5 8 M-3 8 L-3 11 M0 9 L0 12 M3 8 L3 11', stroke: '#5b3a22', 'stroke-width': 1, fill: 'none' }, m);
        S('path', { d: 'M-12 -10 L-6 -6 M-9 -12 L-9 -6', stroke: '#6f9d55', 'stroke-width': 1.2 }, m);
        const x0 = 20 + i * 24, x1 = 250 - i * 20, dir = i % 2 ? -1 : 1;
        const fr = [];
        for (let k = 0; k <= 8; k++) { const u = k / 8; const x = i % 2 ? x1 + (x0 - x1) * u : x0 + (x1 - x0) * u; fr.push({ transform: T(x, -Math.abs(Math.sin(u * Math.PI * 4)) * 60, Math.sin(u * 12) * 18 * dir, 1), offset: u }); }
        go(g, fr, { duration: 1500, delay: i * 180, easing: 'linear' });
      }
    },
    // bones fly in from every direction and snap together into a full skeleton that
    // rattles through a dance, blood leaking from its jaw, before it explodes apart
    bones(p) {
      const BONE = '#f4ecd6', EDGE = '#a89a78';
      const limb = (parent, x1, y1, x2, y2, w) => {
        S('path', { d: 'M' + x1 + ' ' + y1 + ' L' + x2 + ' ' + y2, stroke: EDGE, 'stroke-width': w + 1.4, 'stroke-linecap': 'round' }, parent);
        S('path', { d: 'M' + x1 + ' ' + y1 + ' L' + x2 + ' ' + y2, stroke: BONE, 'stroke-width': w, 'stroke-linecap': 'round' }, parent);
        [[x1, y1], [x2, y2]].forEach((c) => { S('circle', { cx: c[0], cy: c[1], r: w * 0.85, fill: BONE, stroke: EDGE, 'stroke-width': 0.8 }, parent); });
      };
      const body = G(p, cx, 108, 1.2, 0);
      const parts = [];
      // each part: group + start offset; limbs rotate about their joints
      const mk = (build, ox, oy, pivotX, pivotY) => {
        const wrap = S('g', null, body);
        const inner = S('g', null, wrap);
        build(inner);
        parts.push({ inner, ox: ox || 0, oy: oy || 0, px: pivotX || 0, py: pivotY || 0 });
        return inner;
      };
      mk((g) => { const s = G(g, 0, -50, 0.85, 0); part.skull(s, 1); S('path', { d: 'M-5 -36 C-6 -26 -3 -22 -4 -14', stroke: '#c4161c', 'stroke-width': 2.2, fill: 'none', 'stroke-linecap': 'round', opacity: 0.9 }, g); });
      mk((g) => { for (let i = 0; i < 7; i++) S('circle', { cx: 0, cy: -32 + i * 8, r: 2.6, fill: BONE, stroke: EDGE, 'stroke-width': 0.8 }, g); });
      mk((g) => { for (let i = 0; i < 4; i++) { const y = -28 + i * 8; S('path', { d: 'M0 ' + y + ' C-14 ' + (y - 4) + ' -19 ' + (y + 6) + ' -10 ' + (y + 12) + ' M0 ' + y + ' C14 ' + (y - 4) + ' 19 ' + (y + 6) + ' 10 ' + (y + 12), stroke: EDGE, 'stroke-width': 3.6, fill: 'none', 'stroke-linecap': 'round' }, g); S('path', { d: 'M0 ' + y + ' C-14 ' + (y - 4) + ' -19 ' + (y + 6) + ' -10 ' + (y + 12) + ' M0 ' + y + ' C14 ' + (y - 4) + ' 19 ' + (y + 6) + ' 10 ' + (y + 12), stroke: BONE, 'stroke-width': 2.2, fill: 'none', 'stroke-linecap': 'round' }, g); } });
      mk((g) => { S('path', { d: 'M-14 24 C-16 36 -6 38 0 33 C6 38 16 36 14 24 C8 28 -8 28 -14 24Z', fill: BONE, stroke: EDGE, 'stroke-width': 1 }, g); });
      const arm = (sign) => (g) => { limb(g, sign * 10, -32, sign * 26, -12, 3.4); limb(g, sign * 26, -12, sign * 32, 8, 3); };
      const leg = (sign) => (g) => { limb(g, sign * 7, 32, sign * 10, 54, 4); limb(g, sign * 10, 54, sign * 12, 76, 3.6); S('path', { d: 'M' + sign * 12 + ' 76 L' + sign * 22 + ' 78', stroke: BONE, 'stroke-width': 4, 'stroke-linecap': 'round' }, g); };
      mk(arm(-1), 0, 0, -10, -32); mk(arm(1), 0, 0, 10, -32); mk(leg(-1), 0, 0, -7, 32); mk(leg(1), 0, 0, 7, 32);
      parts.forEach((q, i) => {
        const a = (i / parts.length) * Math.PI * 2 + rnd(-0.4, 0.4), d = rnd(170, 240);
        const sx = Math.cos(a) * d, sy = Math.sin(a) * d * 0.8, rot = rnd(-420, 420);
        const dance = i >= 4 ? (i % 2 ? [-24, 30, -16, 26] : [24, -30, 16, -26]) : [0, 0, 0, 0];
        const fr = [
          { transform: T(sx, sy, rot, 0.5), opacity: 0, offset: 0 },
          { transform: T(0, 0, 0, 1.12), opacity: 1, offset: 0.3 + i * 0.03, easing: 'cubic-bezier(.3,1.4,.5,1)' },
          { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.4 + i * 0.03 },
          { transform: T(0, 0, dance[0], 1), offset: 0.5 }, { transform: T(0, 0, dance[1], 1), offset: 0.58 }, { transform: T(0, 0, dance[2], 1), offset: 0.66 }, { transform: T(0, 0, dance[3], 1), offset: 0.74 },
          { transform: T(0, 0, 0, 1), offset: 0.8 },
          { transform: T(-sx * 0.8, sy * 0.4 + 90, -rot, 1), opacity: 0, offset: 1, easing: 'cubic-bezier(.5,0,.9,.6)' },
        ];
        q.inner.style.transformOrigin = q.px + 'px ' + q.py + 'px';
        go(q.inner, fr, { duration: 2100, delay: i * 40 });
      });
      // skeleton bobs as a whole while dancing
      go(body, [{ transform: T(0, 0, 0, 1) }, { transform: T(0, -6, -3, 1), offset: 0.55 }, { transform: T(0, 0, 3, 1), offset: 0.65 }, { transform: T(0, -6, -3, 1), offset: 0.75 }, { transform: T(0, 0, 0, 1) }], { duration: 2100 });
      // clack rings when each bone snaps in and a blood burst at the explosion
      for (let i = 0; i < 4; i++) {
        const r = S('circle', { cx: cx + rnd(-30, 30), cy: 108 + rnd(-40, 30), r: 8, fill: 'none', stroke: '#fff6dc', 'stroke-width': 1.8 }, p);
        r.style.transformBox = 'fill-box'; r.style.transformOrigin = 'center';
        go(r, [{ transform: 'scale(0.3)', opacity: 0 }, { transform: 'scale(0.3)', opacity: 0, offset: 0.2 }, { transform: 'scale(1)', opacity: 1, offset: 0.3 }, { transform: 'scale(2.6)', opacity: 0 }], { duration: 1000, delay: 250 + i * 110 });
      }
      const sp = splat(p, '#c4161c', cx, 108, 1.8);
      go(sp, [{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(0)', opacity: 0, offset: 0.78 }, { transform: 'scale(1.3)', opacity: 1, offset: 0.86 }, { transform: 'scale(1)', opacity: 1, offset: 0.93 }, { transform: 'scale(1)', opacity: 0 }], { duration: 2100 });
      drip(p, '#c4161c', cx - 24, 96, 40, 1700);
      drip(p, '#c4161c', cx + 20, 100, 52, 1760);
    },
    // a cauldron bubbles in the bag with rising rainbow-glow sparks and steam
    cauldron(p) {
      const c = G(p, cx, 140, 2.4, 0);
      part.cauldron(c, 1);
      go(c, [{ transform: T(0, 40, 0, 0.5), opacity: 0 }, { transform: T(0, 0, 0, 1.08), opacity: 1, offset: 0.25 }, { transform: T(0, -2, 0, 1), opacity: 1, offset: 0.85 }, { transform: T(0, 20, 0, 0.8), opacity: 0 }], { duration: 1700 });
      for (let i = 0; i < 9; i++) {
        const b = G(p, cx + rnd(-34, 34), 122, 1, 0);
        part.bubble(b, rnd(3, 7), 'rgba(140,255,120,0.4)');
        go(b, [{ transform: T(0, 0, 0, 0.3), opacity: 0 }, { transform: T(rnd(-10, 10), -26, 0, 1), opacity: 1, offset: 0.4 }, { transform: T(rnd(-24, 24), -80, 0, 1.2), opacity: 0 }], { duration: 1000, delay: 250 + i * 110 });
      }
      for (let i = 0; i < 4; i++) {
        const st = G(p, cx + rnd(-24, 24), 108, 1, 0);
        S('path', { d: 'M0 0 C-8 -10 8 -18 0 -30', stroke: 'rgba(230,255,225,0.7)', 'stroke-width': 5, fill: 'none', 'stroke-linecap': 'round' }, st);
        go(st, [{ transform: T(0, 0, 0, 0.6), opacity: 0 }, { transform: T(0, -26, 0, 1.2), opacity: 0.8, offset: 0.4 }, { transform: T(rnd(-10, 10), -64, 0, 1.5), opacity: 0 }], { duration: 1300, delay: 300 + i * 170 });
      }
      sparks(p, '#d9ff9a', cx, 110, 8, 70, 0.5);
    },
    // rainbow explosion: a prismatic skull pops in over a spinning sunburst while
    // nonpareil sprinkles rain down and pile up, with twinkling stars and a light sweep
    rainbow(p) {
      const cols = ['#ff3b3b', '#ff9a1f', '#ffe14a', '#4bd65a', '#3b9bff', '#8a4bff', '#ff4bd0'];
      // sunburst rays
      const burst = G(p, cx, 104, 1, 0);
      for (let i = 0; i < 14; i++) S('path', { d: 'M0 0 L-9 -150 L9 -150Z', fill: cols[i % 7], opacity: 0.5, transform: 'rotate(' + i * (360 / 14) + ')' }, burst);
      go(burst, [{ transform: 'rotate(0deg) scale(0)', opacity: 0 }, { transform: 'rotate(80deg) scale(1)', opacity: 1, offset: 0.25 }, { transform: 'rotate(280deg) scale(1)', opacity: 0.9, offset: 0.8 }, { transform: 'rotate(360deg) scale(1.1)', opacity: 0 }], { duration: 1800, easing: 'linear' });
      // glowing rainbow arcs underneath
      cols.forEach((c, i) => {
        const arc = S('path', { d: 'M' + (30 + i * 6) + ' ' + (floor + 6) + ' A' + (110 - i * 6) + ' ' + (110 - i * 6) + ' 0 0 1 ' + (250 - i * 6) + ' ' + (floor + 6), stroke: c, 'stroke-width': 6, fill: 'none', pathLength: 1, 'stroke-linecap': 'round', filter: 'url(#fxglow)' }, p);
        arc.style.strokeDasharray = 1;
        go(arc, [{ strokeDashoffset: 1, opacity: 1 }, { strokeDashoffset: 0, opacity: 1, offset: 0.35 }, { strokeDashoffset: 0, opacity: 1, offset: 0.75 }, { strokeDashoffset: 0, opacity: 0 }], { duration: 1700, delay: i * 45 });
      });
      // the prismatic skull
      const sp = G(p, cx, 104, 2.5, 0);
      const sk = part.skull(sp, 1);
      sk.querySelector('path').setAttribute('fill', 'url(#fxrainbow)');
      sk.querySelector('path').setAttribute('filter', 'url(#fxglow)');
      go(sp, [{ transform: T(0, 30, 0, 0.1), opacity: 0 }, { transform: T(0, 0, -6, 1.3), opacity: 1, offset: 0.25 }, { transform: T(0, 0, 4, 1.0), opacity: 1, offset: 0.4 }, { transform: T(0, 0, -3, 1.08), opacity: 1, offset: 0.6 }, { transform: T(0, 0, 0, 1.0), opacity: 1, offset: 0.8 }, { transform: T(0, -30, 0, 1.5), opacity: 0 }], { duration: 1800 });
      // sprinkles raining and piling up
      for (let i = 0; i < 70; i++) {
        const x = rnd(40, 240);
        const sc = G(p, x, -8, 1, rnd(0, 180));
        S('rect', { x: -1.1, y: -3.4, width: 2.2, height: 6.8, rx: 1.1, fill: pick(cols) }, sc);
        const rest = floor + rnd(-12, 6) + (Math.abs(x - cx) < 70 ? -8 : 0);
        go(sc, [{ transform: T(0, 0, 0), opacity: 1 }, { transform: T(rnd(-10, 10), rest, rnd(0, 540)), opacity: 1, offset: 0.55, easing: 'cubic-bezier(.5,0,.9,.6)' }, { transform: T(rnd(-10, 10), rest - rnd(0, 14), rnd(0, 540)), opacity: 1, offset: 0.65, easing: 'cubic-bezier(.1,.6,.4,1)' }, { transform: T(rnd(-12, 12), rest, rnd(0, 540)), opacity: 1, offset: 0.8 }, { transform: T(0, rest, 0), opacity: 0 }], { duration: 1900, delay: rnd(100, 700) });
      }
      // twinkling stars
      for (let i = 0; i < 12; i++) {
        const s = G(p, rnd(36, 244), rnd(50, 170), 1, 0);
        part.star(s, pick(['#ffffff', '#fff6a0', '#ffd0f0']), rnd(0.5, 1));
        go(s, [{ transform: T(0, 0, 0, 0), opacity: 0 }, { transform: T(0, 0, 45, 1.2), opacity: 1, offset: 0.5 }, { transform: T(0, 0, 90, 0), opacity: 0 }], { duration: 700, delay: rnd(200, 1300) });
      }
      // light sweep
      const sw = S('rect', { x: 0, y: 0, width: 36, height: 220, fill: 'rgba(255,255,255,0.5)', filter: 'url(#fxblur)', transform: 'rotate(18)' }, p);
      go(sw, [{ transform: 'translate(-60px,-20px) rotate(18deg)', opacity: 0 }, { opacity: 1, offset: 0.2 }, { transform: 'translate(340px,-20px) rotate(18deg)', opacity: 0 }], { duration: 1000, delay: 300 });
    },
    // a shaken soda: the bottle rattles, the cap rockets off, and a foam geyser sprays
    // fizzing droplets while a sticky tide of foam rises, then settles
    fizz(p) {
      const liquid = pick(['#3bb6ff', '#ff5fa8']);
      const bt = G(p, cx, 118, 1.7, 0);
      const bg = S('g', null, bt);
      S('path', { d: 'M-5 -46 L5 -46 L5 -26 C16 -20 18 -10 18 0 L18 40 C18 50 12 54 0 54 C-12 54 -18 50 -18 40 L-18 0 C-18 -10 -16 -20 -5 -26Z', fill: 'rgba(210,235,255,0.35)', stroke: 'rgba(255,255,255,0.9)', 'stroke-width': 1.6 }, bg);
      S('path', { d: 'M-17 6 C-9 2 9 10 17 5 L17 40 C17 49 12 52 0 52 C-12 52 -17 49 -17 40Z', fill: liquid, opacity: 0.85 }, bg);
      S('rect', { x: -17, y: 14, width: 34, height: 18, fill: '#1a0b2e' }, bg);
      const lab = part.skull(S('g', { transform: 'translate(0 23)' }, bg), 0.5);
      for (let i = 0; i < 10; i++) { const b = S('circle', { cx: rnd(-12, 12), cy: rnd(8, 46), r: rnd(1, 2.2), fill: 'rgba(255,255,255,0.85)' }, bg); go(b, [{ transform: 'translateY(0)' }, { transform: 'translateY(-10px)' }], { duration: 300, iterations: 6, direction: 'alternate' }); }
      go(bt, [{ transform: T(0, 40, 0, 0.4), opacity: 0 }, { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.12 }, { transform: T(-4, 0, -6, 1), offset: 0.18 }, { transform: T(4, 0, 6, 1), offset: 0.24 }, { transform: T(-5, 0, -7, 1), offset: 0.3 }, { transform: T(5, 0, 7, 1), offset: 0.36 }, { transform: T(0, -6, 0, 1.06), offset: 0.42 }, { transform: T(0, 0, 0, 1), offset: 0.7 }, { transform: T(0, 30, 0, 0.8), opacity: 0 }], { duration: 1900 });
      // cap rockets off
      const cap = G(p, cx, 62, 1.6, 0);
      S('ellipse', { rx: 8, ry: 3, fill: '#d0d6e0', stroke: '#8b93a3' }, cap);
      for (let i = 0; i < 7; i++) S('path', { d: 'M' + (-7 + i * 2.3) + ' -2.4 L' + (-7 + i * 2.3) + ' 2.4', stroke: '#8b93a3', 'stroke-width': 0.8 }, cap);
      go(cap, [{ transform: T(0, 0, 0, 1), opacity: 0 }, { transform: T(0, 0, 0, 1), opacity: 0, offset: 0.4 }, { transform: T(10, -70, 360, 1.1), opacity: 1, offset: 0.55 }, { transform: T(26, 120, 900, 1), opacity: 0 }], { duration: 1500, easing: 'cubic-bezier(.2,.7,.4,1)' });
      // pressure rings at the neck
      for (let i = 0; i < 3; i++) {
        const r = S('circle', { cx, cy: 70, r: 10, fill: 'none', stroke: 'rgba(255,255,255,0.9)', 'stroke-width': 2 }, p);
        r.style.transformBox = 'fill-box'; r.style.transformOrigin = 'center';
        go(r, [{ transform: 'scale(0.3)', opacity: 0 }, { transform: 'scale(0.3)', opacity: 0, offset: 0.4 }, { transform: 'scale(0.5)', opacity: 1, offset: 0.45 }, { transform: 'scale(4)', opacity: 0 }], { duration: 1300, delay: i * 80 });
      }
      // foam geyser: white blobs and liquid drops launched in a fan, falling with gravity
      for (let i = 0; i < 46; i++) {
        const isDrop = i % 3 === 0;
        const g = G(p, cx, 66, 1, rnd(-30, 30));
        if (isDrop) part.drop(g, liquid, rnd(0.5, 0.9)); else S('circle', { r: rnd(3, 8), fill: pick(['#ffffff', '#eaf6ff', '#ffe9f5']), opacity: 0.95 }, g);
        const ang = rnd(-1.15, 1.15), v = rnd(70, 150);
        const xa = Math.sin(ang) * v, ya = -Math.cos(ang) * v;
        go(g, [{ transform: T(0, 0, 0, 0.4), opacity: 0 }, { transform: T(0, 0, 0, 0.4), opacity: 0, offset: 0.38 }, { transform: T(xa * 0.6, ya, 0, 1), opacity: 1, offset: 0.55, easing: 'cubic-bezier(.1,.6,.4,1)' }, { transform: T(xa, ya + floor + 40, rnd(-60, 60), 0.9), opacity: 1, offset: 0.85, easing: 'cubic-bezier(.5,0,.9,.6)' }, { transform: T(xa, ya + floor + 50, 0, 0.9), opacity: 0 }], { duration: 1900, delay: i * 14 });
      }
      // continuous fizz field
      for (let i = 0; i < 26; i++) {
        const b = G(p, rnd(44, 236), floor, 1, 0);
        part.bubble(b, rnd(2, 6), 'rgba(255,255,255,0.2)');
        go(b, [{ transform: T(0, 0, 0, 0.5), opacity: 0 }, { transform: T(rnd(-10, 10), -60, 0, 1), opacity: 1, offset: 0.4 }, { transform: T(rnd(-14, 14), -130, 0, 1.2), opacity: 0 }], { duration: rnd(800, 1300), delay: 600 + i * 40 });
      }
      // sticky streaks running down the glass + foam tide
      for (let i = 0; i < 6; i++) drip(p, liquid, rnd(54, 226), rnd(54, 90), rnd(26, 60), 800 + i * 110);
      let fd = 'M30 ' + (floor + 14);
      for (let x = 30; x < 250; x += 22) fd += ' Q' + (x + 11) + ' ' + (floor - rnd(16, 34)) + ' ' + (x + 22) + ' ' + (floor + 6);
      fd += ' L252 ' + (floor + 18) + ' L30 ' + (floor + 18) + 'Z';
      const foam = S('path', { d: fd, fill: 'rgba(255,255,255,0.92)' }, p);
      go(foam, [{ transform: 'translateY(60px)', opacity: 0 }, { transform: 'translateY(60px)', opacity: 0, offset: 0.4 }, { transform: 'translateY(-26px)', opacity: 1, offset: 0.75 }, { transform: 'translateY(-14px)', opacity: 1, offset: 0.9 }, { transform: 'translateY(30px)', opacity: 0 }], { duration: 2000 });
    },
    // fruit burst: a drawn fruit splits, juice splashes the glass, seeds/arils pop out
    fruit(p, o) {
      o = o || {};
      const f = G(p, cx, 104, 2.4, 0);
      (o.draw || ((g) => part.berry(g, o.juice, 1)))(f);
      go(f, [{ transform: T(0, -40, 0, 0.2), opacity: 0 }, { transform: T(0, 0, 0, 1.3), opacity: 1, offset: 0.3 }, { transform: T(0, 0, 14, 1.5), opacity: 1, offset: 0.5 }, { transform: T(0, 0, 0, 0.1), opacity: 0, offset: 0.55 }, { transform: T(0, 0, 0, 0.1), opacity: 0 }], { duration: 1400 });
      const sp = splat(p, o.juice, cx, 104, 1.8);
      go(sp, [{ transform: 'scale(0)', opacity: 0 }, { transform: 'scale(0)', opacity: 0, offset: 0.45 }, { transform: 'scale(1.3)', opacity: 1, offset: 0.58 }, { transform: 'scale(1)', opacity: 1, offset: 0.8 }, { transform: 'scale(1)', opacity: 0 }], { duration: 1700 });
      drip(p, o.juice, cx - 22, 112, 30, 700);
      drip(p, o.juice, cx + 26, 108, 40, 800);
      for (let i = 0; i < (o.bits || 9); i++) {
        const b = G(p, cx, 104, 1, 0);
        (o.bit || ((g) => S('circle', { r: 2.4, fill: o.seed || '#222' }, g)))(b);
        const a = rnd(0, Math.PI * 2), d = rnd(40, 100);
        go(b, [{ transform: T(0, 0, 0, 0.3), opacity: 0 }, { transform: T(0, 0, 0, 0.3), opacity: 0, offset: 0.45 }, { transform: T(Math.cos(a) * d, Math.sin(a) * d * 0.8 - 20, rnd(-180, 180), 1), opacity: 1, offset: 0.7 }, { transform: T(Math.cos(a) * d * 1.1, Math.sin(a) * d + 40, rnd(-240, 240), 0.8), opacity: 0 }], { duration: 1500, delay: 40 * i });
      }
    },
  };

  // fruit variants built on the shared "fruit" scene
  const fruitScenes = {
    passion: (p) => SCENES.fruit(p, {
      juice: '#ffb81a', seed: '#4a2a10', bits: 12,
      draw: (g) => { S('circle', { r: 13, fill: '#7a3d8a', stroke: '#4a1f5e', 'stroke-width': 1.4 }, g); S('circle', { r: 9.4, fill: '#ffd25a' }, g); for (let i = 0; i < 8; i++) S('ellipse', { cx: Math.cos(i * 0.8) * 5, cy: Math.sin(i * 0.8) * 5, rx: 1.6, ry: 2.2, fill: '#4a2a10' }, g); },
    }),
    pomegranate: (p) => SCENES.fruit(p, {
      juice: '#b3122b', bits: 14,
      draw: (g) => part.cherry(g, 1.1),
      bit: (g) => { S('path', { d: 'M0 -3 C3 -1 3 2 0 3 C-3 2 -3 -1 0 -3Z', fill: '#c4161c' }, g); S('circle', { cx: -0.8, cy: -0.8, r: 0.8, fill: 'rgba(255,255,255,0.6)' }, g); },
    }),
    dragon: (p) => {
      SCENES.fruit(p, {
        juice: '#e83f9a', seed: '#1a0b2e', bits: 10,
        draw: (g) => { S('circle', { r: 13, fill: '#ec4a9d', stroke: '#9d1f64', 'stroke-width': 1.4 }, g); S('circle', { r: 9, fill: '#fde9f4' }, g); for (let i = 0; i < 9; i++) S('circle', { cx: rnd(-6, 6), cy: rnd(-6, 6), r: 0.9, fill: '#1a0b2e' }, g); for (let i = 0; i < 6; i++) S('path', { d: 'M0 -13 L-2 -19 L2 -19Z', fill: '#4bd65a', transform: 'rotate(' + i * 60 + ')' }, g); },
      });
      const fl = G(p, cx + 60, 128, 1.3, 70);
      part.flame(fl, 1.1);
      go(fl, [{ transform: T(0, 0, 0, 0.1), opacity: 0 }, { transform: T(0, 0, 0, 1.4), opacity: 1, offset: 0.4 }, { transform: T(0, 0, 0, 1.0), opacity: 0 }], { duration: 1200, delay: 450 });
    },
    blueberry: (p) => SCENES.fruit(p, {
      juice: '#4b4bd6', bits: 8,
      draw: (g) => { part.berry(g, '#3d4bd6', 1); const r = G(g, 14, 6, 0.9, 0); part.raspberry(r, 1); },
      bit: (g) => part.berry(g, pick(['#3d4bd6', '#d6246e']), 0.35),
    }),
    lemon: (p) => SCENES.fruit(p, {
      juice: '#ffe14a', bits: 8,
      draw: (g) => { part.lemon(g, 1); const r = G(g, 16, 8, 0.9, 0); part.raspberry(r, 1); },
      bit: (g) => S('path', { d: 'M0 -3 C3 -1 3 2 0 3 C-3 2 -3 -1 0 -3Z', fill: '#fff07a' }, g),
    }),
    poisonpink: (p) => {
      SCENES.potion(p, '#ff5fa8');
      const sk = G(p, cx, 74, 1.4, 0);
      part.skull(sk, 1);
      S('path', { d: 'M-12 -22 L12 22 M12 -22 L-12 22', stroke: '#fff', 'stroke-width': 2.4, 'stroke-linecap': 'round' }, sk.parentNode);
      go(sk, [{ transform: T(0, 20, 0, 0.2), opacity: 0 }, { transform: T(0, 0, 0, 1.2), opacity: 1, offset: 0.35 }, { transform: T(0, 0, 0, 1), opacity: 1, offset: 0.7 }, { transform: T(0, -20, 0, 0.8), opacity: 0 }], { duration: 1400, delay: 200 });
    },
    // rotten: flies buzz, stink lines wave, green mold blooms on the glass
    rotten(p) {
      for (let i = 0; i < 14; i++) {
        const m = S('circle', { cx: rnd(50, 230), cy: rnd(60, 170), r: rnd(4, 11), fill: pick(['#6b8a2a', '#8aa83a', '#4c6a1e']), opacity: 0.55 }, p);
        m.style.transformBox = 'fill-box'; m.style.transformOrigin = 'center';
        go(m, [{ transform: 'scale(0)', opacity: 0.55 }, { transform: 'scale(1)', opacity: 0.55, offset: 0.5 }, { transform: 'scale(1)', opacity: 0.55, offset: 0.8 }, { transform: 'scale(1)', opacity: 0 }], { duration: 1600, delay: i * 50 });
      }
      for (let i = 0; i < 4; i++) {
        const st = G(p, 70 + i * 48, 150, 1, 0);
        S('path', { d: 'M0 0 q-5 -8 0 -14 q5 -6 0 -14 q-5 -8 0 -14', stroke: '#9bd04a', 'stroke-width': 2.4, fill: 'none', 'stroke-linecap': 'round' }, st);
        go(st, [{ transform: T(0, 0), opacity: 0 }, { transform: T(0, -26), opacity: 0.9, offset: 0.4 }, { transform: T(rnd(-8, 8), -70), opacity: 0 }], { duration: 1400, delay: i * 140 });
      }
      for (let i = 0; i < 5; i++) {
        const f = G(p, cx, 100, 1.6, 0);
        const fl = part.fly(f, 1);
        const pts = [];
        for (let k = 0; k <= 12; k++) pts.push({ transform: T(cx * 0 + Math.cos(k * 1.1 + i) * rnd(30, 80) + rnd(-10, 10), Math.sin(k * 1.7 + i * 2) * rnd(20, 44), rnd(-40, 40), 1), opacity: k === 0 || k === 12 ? 0 : 1, offset: k / 12 });
        go(f, pts, { duration: 1700, delay: i * 90, easing: 'linear' });
        go(fl.w1, [{ transform: 'rotate(-30deg) scaleY(1)' }, { transform: 'rotate(-30deg) scaleY(0.2)' }], { duration: 70, iterations: 30, direction: 'alternate' });
        go(fl.w2, [{ transform: 'rotate(30deg) scaleY(1)' }, { transform: 'rotate(30deg) scaleY(0.2)' }], { duration: 70, iterations: 30, direction: 'alternate' });
      }
    },
  };

  const META = {
    _default: { c: '#ff7a1a', k: 'jolt', icon: ICONS.skull, scene: (p) => { sparks(p, '#ff9f43', cx, 104, 10, 80, 0.6); } },
    'witch-ball': { c: '#B46BFF', k: 'pulse', icon: ICONS.orb, scene: SCENES.orb },
    'inferno-skulls': { c: '#FF6A1A', k: 'flicker', icon: ICONS.flame, scene: SCENES.inferno },
    'dizzy-deadheads': { c: '#7FD6FF', k: 'wobble', icon: ICONS.skull, scene: SCENES.dizzy },
    'unearthed-skulls': { c: '#8A6B3E', k: 'jolt', icon: ICONS.bone, scene: SCENES.unearthed },
    'black-magic-skulls': { c: '#7B3FE4', k: 'pulse', icon: ICONS.skull, scene: SCENES.blackmagic },
    'poison-pink-skulls': { c: '#FF5FA8', k: 'jolt', icon: ICONS.bottleP, scene: fruitScenes.poisonpink },
    'rotten-skulls': { c: '#7A9B2E', k: 'wobble', icon: ICONS.skull, scene: fruitScenes.rotten },
    'blood-splattered-skulls': { c: '#C4161C', k: 'jolt', icon: ICONS.drop, scene: SCENES.splatter },
    'radioactive-skulls': { c: '#7CFF3C', k: 'flicker', icon: ICONS.trefoil, scene: SCENES.radioactive },
    'severed-fingers': { c: '#E8A0A0', k: 'jolt', icon: ICONS.finger, scene: SCENES.fingers },
    'zombie-fingers': { c: '#6FA05A', k: 'wobble', icon: ICONS.hand, scene: SCENES.zombiehand },
    'vampire-tongues': { c: '#E0457B', k: 'jolt', icon: ICONS.tongue, scene: SCENES.tongue },
    'vampire-lips': { c: '#D40F4F', k: 'pulse', icon: ICONS.lips, scene: SCENES.lips },
    'blood-berry-bites': { c: '#B3122B', k: 'none', icon: ICONS.drop, scene: SCENES.bloodberry },
    'poison-potion-bottles': { c: '#5CFF7A', k: 'pulse', icon: ICONS.bottle, scene: (p) => SCENES.potion(p, '#5cff7a') },
    'zombie-monkeys': { c: '#7BA05B', k: 'wobble', icon: ICONS.skull, scene: SCENES.monkey },
    'bloody-bones-sour-strawberry': { c: '#C4161C', k: 'shake', icon: ICONS.bone, scene: SCENES.bones },
    'witch-potion-bottles': { c: '#A66BFF', k: 'pulse', icon: ICONS.cauldron, scene: SCENES.cauldron },
    'sour-rainbow-skulls': { c: '#FFD04A', k: 'pulse', icon: ICONS.star, scene: SCENES.rainbow },
    'fizzy-skulls': { c: '#CFEFFF', k: 'shake', icon: ICONS.bubble, scene: SCENES.fizz },
    'sour-passion-fruit-skulls': { c: '#FFC51A', k: 'jolt', icon: ICONS.drop, scene: fruitScenes.passion },
    'sour-pomegranate-cherry-skulls': { c: '#C4161C', k: 'jolt', icon: ICONS.cherry, scene: fruitScenes.pomegranate },
    'sour-dragon-fruit-skulls': { c: '#FF3FA0', k: 'flicker', icon: ICONS.flame, scene: fruitScenes.dragon },
    'sour-blueberry-raspberry-skulls': { c: '#5B6BFF', k: 'jolt', icon: ICONS.raspberry, scene: fruitScenes.blueberry },
    'sour-raspberry-lemon-skulls': { c: '#FFE14A', k: 'jolt', icon: ICONS.lemon, scene: fruitScenes.lemon },
  };

  window.MixFX = {
    meta(handle) { return META[handle] || META._default; },
    icon,
    // plays the scene for this candy inside `host` (a positioned element the size of the bag)
    scene(handle, host) {
      const m = META[handle] || META._default;
      const st = stage(host);
      try { m.scene(st.svg); } catch (e) { console.error('MixFX scene failed', handle, e); }
      return st.svg;
    },
  };
})();
